import React from "react";

// assets
import CameraIcon from "bodycodi/cmap/app/svg/video_progress_camera.svg";

const VideoProgress = () => {
  return (
    <div className="video-progress">
      <div className="icon-wrapper">
        <div className="circle-rotate"></div>
        <div className="icon">
          <img src={CameraIcon} />
        </div>
      </div>

      <div className="text-wrapper">
        <span className="primary">동영상 업로드 중...</span>
        <span className="secondary">조금만 기다려주세요!</span>
      </div>
    </div>
  );
};

export default VideoProgress;
